module.exports = __webpack_public_path__ + "img/ck.b5ac3b3a.png";